// app/javascript/controllers/variant_updater_controller.js
import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

/**
 * Controller for handling variant option changes and updating product details
 * without submitting the main form
 */
export default class extends Controller {
  static values = {
    updateUrl: String
  }
  
  static targets = ["optionField", "changedField"]
  
  connect() {
    // Initialization if needed
  }
  
  /**
   * Handle when an option changes and request updated content
   * @param {Event} event - The change event
   */
  async optionChanged(event) {
    // Set which option changed
    this.changedFieldTarget.value = event.target.dataset.optionId;
    
    // Create the URL with query parameters
    const url = new URL(this.updateUrlValue, window.location.origin);
    
    // Add form data to the URL
    const formData = new FormData(this.element);
    for (const [key, value] of formData.entries()) {
      url.searchParams.append(key, value);
    }
    
    try {
      // Use rails/request.js to make the request
      // This automatically handles Turbo Stream responses
      await get(url.toString(), {
        responseKind: "turbo-stream"
      });
    } catch (error) {
      console.error("Error updating variant options:", error);
    }
  }
}